import { useI18n } from "@/lib/i18n";

export default function LanguageToggle({ tone = "dark" }) {
  const { lang, setLang } = useI18n();
  const onDark = tone === "dark";

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center gap-1 font-mono-accent text-[12px] border ${
        onDark ? "border-[#FDFBF7]/30 text-[#FDFBF7]" : "border-[#1A1713]/30 text-[#1A1713]"
      }`}
    >
      {["en", "es"].map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-${code}`}
          className={`px-2.5 py-1.5 transition-colors duration-300 ${
            lang === code
              ? onDark
                ? "bg-[#C98A4B] text-[#1A1713]"
                : "bg-[#1A1713] text-[#FDFBF7]"
              : "opacity-60 hover:opacity-100"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
